<div class="side-app">
  <div class="sub-header">
    <div class="main-container container">
      <div class="row">
        <div class="col-6 col-sm-9 col-md-10">
          <h1 class="page-title pt-1">Summary</h1>
        </div>
        <div class="col-6 col-sm-3 col-md-2">
          <!-- <div class="input-group">
          <mbsc-datepicker
            class="form-control fs-12"
            #rangeDatepicker
            [options]="dateRangeOptions"
          placeholder="Select date range" ></mbsc-datepicker>
          <button class="input-group-text bg-white"
            type="button"
            (click)="rangeDatepicker.open()">
            <i class="fa fa-calendar"></i>
          </button>
        </div> -->
      </div>
    </div>
  </div>
</div>
<div class="{{ configJson.container }}">
  @for (mainRrow of configJson.rows; track mainRrow) {
    <div class="row {{ mainRrow.row?.className }}">
      @for (col of mainRrow.row.col; track col) {
        <div class="col-12 col-{{ col.size }}">
          @for (nestedRow of col.rows; track nestedRow) {
            <div class="row">
              @for (nestedCol of nestedRow.row.col; track nestedCol) {
                <div
                  class="col-12 col-{{ nestedCol.size }} {{ nestedCol.className }}">
                  @if (nestedCol.components.length) {
                    <div>
                      @if (nestedCol.components.includes('PatientCountWidget')) {
                        <div>
                          <div class="card p-4">
                            <div class="d-flex">
                              <div class="notifyimg bg-info">
                                <i class="fa fa-user"></i>
                              </div>
                              <div class="flex-fill d-flex align-items-stretch text-nowrap">
                                <div class="d-sm-flex w-100">
                                  <div class="flex-fill border-sm-end px-4 card-style3 py-1">
                                    <app-data-card [cardData]="patients"></app-data-card>
                                  </div>
                                  <div class="flex-fill border-sm-end px-4 card-style3 py-1">
                                    <app-data-card [cardData]="engagedPatients"></app-data-card>
                                  </div>
                                  <div class="flex-fill  px-4 card-style3 py-1">
                                    <app-data-card [cardData]="assessedPatients"></app-data-card>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      @if (nestedCol.components.includes('AdmissionsCountWidget')) {
                        <div>
                          <div class="card p-4">
                            <div class="d-flex">
                              <div class="notifyimg bg-info">
                                <i class="fa fa-bed"></i>
                              </div>
                              <div class="flex-fill d-flex align-items-stretch text-nowrap">
                                <div class="d-sm-flex w-100">
                                  <div class="flex-fill border-sm-end px-4 card-style3 py-1">
                                    <app-data-card [cardData]="admissions"></app-data-card>
                                  </div>
                                  <div class="flex-fill px-4 mt-3 mt-sm-0 py-1">
                                    <app-data-card [cardData]="admissionRecent"></app-data-card>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      @if (nestedCol.components.includes('QualityMatricsWidget')) {
                        <div>
                          <app-description-card [cardData]="qualityMatrics"></app-description-card>
                        </div>
                      }
                      @if (nestedCol.components.includes('RiskStratificationWidget')) {
                        <div>
                          <app-description-card [cardData]="providerMetrics"></app-description-card>
                        </div>
                      }
                      @if (nestedCol.components.includes('PatientByStage')) {
                        <div>
                          <app-patient-by-stage></app-patient-by-stage>
                        </div>
                      }
                      @if (nestedCol.components.includes('PatientByRiskCategory')) {
                        <div>
                          <app-progress-bar-chart-widget [config]="patientByRiskCategor"></app-progress-bar-chart-widget>
                        </div>
                      }
                      @if (nestedCol.components.includes('PatientByComorbidity')) {
                        <div>
                          <app-progress-bar-chart-widget [config]="patientByComorbidity"></app-progress-bar-chart-widget>
                        </div>
                      }
                      @if (nestedCol.components.includes('HoldPatients')) {
                        <div>
                          <app-hold-patients></app-hold-patients>
                        </div>
                      }
                      @if (nestedCol.components.includes('PatientByAgeGroup')) {
                        <div>
                          <app-progress-bar-chart-widget [config]="patientByAgeGroup"></app-progress-bar-chart-widget>
                        </div>
                      }
                      @if (nestedCol.components.includes('CareTeam')) {
                        <div>
                          <app-care-team></app-care-team>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
</div>